<template>
  <div v-if="isShow">
    <lottery-more
      class="lottery-more"
      title="往期中奖名单"
      v-on:moreaction="moreList"
    />
    <div class="winners_bg">
      <LotteryTitle class="lotteryTitle" titleName="本期中奖名单" />
      <div class="winners_list_div">
        <img
          class="list_bg_image"
          src="../../assets/lottery/winning_decoration_bg.png"
        />
        <div class="luck_code" v-if="curWinner != null">
          {{ curWinner.luckyCode }}
        </div>
        <div class="user_name" v-if="curWinner != null">
          {{ curWinner.userName }}
        </div>
      </div>
      <button class="button winners_list_btn_all" @click="allLuckCode">
        幸运码全览
      </button>
    </div>
  </div>
  <div class="not_data" v-else></div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { CurWinner } from "../../model/lottery/LotteryModel";
import LotteryTitle from "../../components/lottery/LotteryTit.vue";
import LotteryMore from "../../components/lottery/LotteryMore.vue";
import { openToast } from "toast-ts";
@Options({
  components: {
    LotteryTitle,
    LotteryMore
  }
})
export default class WinnersList extends Vue {
  isShow = false;
  curWinner: CurWinner | null = null;
  mounted() {
    Http.get<CurWinner>(Urls.lottery_curWinner).then(
      (res: CurWinner) => {
        this.curWinner = res;
        this.isShowWinner();
      },
      (err: ResponseData) => {
        console.log("WinnersList:", err.message);
        openToast(err.message);
      }
    );
  }
  isShowWinner() {
    if (
      this.curWinner != null &&
      this.curWinner.luckyCode.length > 0 &&
      this.curWinner.userName.length > 0
    ) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }
  moreList() {
    this.$router.push("/pasewinners/list");
  }
  allLuckCode() {
    this.$router.push("/luckycodes/list");
  }
}
</script>

<style scoped lang="less">
@import "../../style/BaseStyle.less";
.not_data {
  height: 20px;
  width: 100%;
  overflow: hidden;
}
.lottery-more {
  margin-top: 20px;
}

.winners_bg {
  margin: 10px 20px 20px 20px;
  width: ~"calc(100%-40px)";
  background-color: white;
  border-radius: 10px;
  padding: 19px 0px 21px 0px;
  height: auto;
  overflow: hidden;
  text-align: center;
  /// 本期中奖名单 - title
  .winners_imag_title_bg {
    padding: 0px;
    width: 100%;
    display: flex;
    text-align: center;
    margin: 0 auto;
    display: flex;
    justify-content: center;

    .winners_title {
      text-align: center;
      margin: 0 auto;
      margin-left: 6px;
      margin-right: 6px;
      font-size: 15px;
      font-weight: bold;
      color: #111111;
    }
  }
  /// 中奖名单
  .winners_list_div {
    overflow: hidden;
    float: left;
    margin: 0 auto;
    text-align: center;
    margin-top: 16px;
    .list_bg_image {
      position: absolute;
      left: 0;
      right: 0;
      justify-content: center;
      align-content: center;
      margin: 0 auto;
      // height: 48px;
      width: 80%;
    }
    .user_name {
      width: 25%;
      position: absolute;
      left: 25%;
      text-align: left;
      margin-top: 11px;
      font-weight: bold;
      color: #ffffff;
      font-size: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      // background-color: yellow;
    }
    .luck_code {
      // background-color: yellow;
      width: 20%;
      text-align: right;
      position: absolute;
      right: 25%;
      margin-top: 11px;
      font-weight: bold;
      text-align: right;
      color: #ffffff;
      font-size: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .winners_list_btn_all {
    margin-top: 84px;
    padding: 5px 18px;
    color: #f84d4d;
    border: 1px solid #f84d4d;
    border-radius: 30px;
  }
}
</style>
